<template>
  <section>
    <div class="search">
      <label>
        <label class="input-top-label">{{
          t.getOrKey("Label.YourLocation")
        }}</label>
        <gmap-autocomplete
          @place_changed="setPlace"
          @focus="tryGetUserPosition"
          placeholder="Kaupunki tai katuosoite"
        ></gmap-autocomplete>
      </label>
      <slot></slot>
    </div>

    <div class="col-md-8">
      <GmapMap
        :center="center"
        :zoom="zoom"
        map-type-id="terrain"
        ref="map"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUI: false,
        }"
      >
        <gmap-info-window
          v-if="infoItem && infoItem.provider"
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div
            :class="{
              'info-window': true,
              selected:
                infoItem &&
                infoItem.provider &&
                infoItem.provider.id &&
                selectedProvider &&
                selectedProvider.id &&
                infoItem.provider.id === selectedProvider.id,
            }"
          >
            <div class="font-bold">{{ infoItem.provider.name }}</div>
            <div>{{ infoItem.provider.street }}</div>
            <div>
              {{ infoItem.provider.city }}
              {{ infoItem.provider.postalCode }}
            </div>
            <div>{{ infoItem.provider.phone }}</div>
            <a
              target="blank"
              :href="
                `https://maps.google.com/maps?daddr=${infoItem.provider.street}, ${infoItem.provider.postalCode} ${infoItem.provider.city}`
              "
              >{{ t.getOrKey("Label.Directions") }}</a
            >
            <div class="buttons">
              <button
                class="error button-xs"
                v-if="
                  infoItem &&
                    infoItem.provider &&
                    infoItem.provider.id &&
                    selectedProvider &&
                    selectedProvider.id &&
                    infoItem.provider.id === selectedProvider.id
                "
                type="button"
                @click="$emit('change', undefined)"
              >
                {{ t.getOrKey("Button.RemoveSelection") }}
              </button>
              <button
                class="primary button-xs"
                v-else
                type="button"
                @click="selectProvider(infoItem)"
              >
                {{ t.getOrKey("Button.Select") }}
              </button>
            </div>
          </div>
        </gmap-info-window>
        <GmapMarker
          :icon="{
            path:
              'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
            fillColor: '#0047bb',
            fillOpacity: 1,
            strokeColor: 'black',
            scale: 1.4,
            anchor: { x: 12, y: 24 },
          }"
          :key="m.provider.id"
          v-for="m in markers"
          :position="m.position"
          :clickable="true"
          @click="toggleInfoWindow(m)"
        />
      </GmapMap>
    </div>
  </section>
</template>

<script>
import t from "@/services/translation-service";
//import marker from "@/assets/";

const initialZoom = 5;
const closerZoom = 10;
const providerSelectedZoom = 13;

const initialMapCenter = { lat: 64.22728, lng: 27.72846 };

const providerToMarker = (provider) => {
  return {
    provider: provider,
    position: {
      lat: Number(provider.coordinates.lat),
      lng: Number(provider.coordinates.lon),
    },
  };
};

export default {
  props: {
    providers: Array,
    selectedProvider: Object,
  },
  watch: {
    providers() {
      this.providersChanged();
    },
    selectedProvider(newProvider) {
      if (newProvider) {
        const marker = providerToMarker(this.selectedProvider);
        this.infoItem = marker;
        this.infoWindowPos = marker.position;
        this.selectProvider(marker);
        this.infoWinOpen = true;
      } else {
        this.infoItem = {};
        this.infoWinOpen = false;
        this.infoWindowPos = null;

        this.center = initialMapCenter;
        this.zoom = initialZoom;
        this.$emit("change", undefined);
      }
    },
  },
  data() {
    return {
      center: initialMapCenter,
      zoom: initialZoom,
      infoItem: {},
      t: t,
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      markers: [],
      place: null,

      userPositionTry: true,
    };
  },

  methods: {
    tryGetUserPosition() {
      const vm = this;
      if (navigator.geolocation && this.userPositionTry) {
        const success = (position) => {
          vm.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          vm.zoom = closerZoom;
        };

        navigator.geolocation.getCurrentPosition(success);
      }
      this.userPositionTry = true;
    },
    toggleInfoWindow(marker) {
      if (
        this.infoItem &&
        this.infoItem.provider &&
        marker.provider.id === this.infoItem.provider.id
      ) {
        this.infoWinOpen = false;
      } else {
        this.infoWindowPos = marker.position;
        this.infoItem = marker;
        this.infoWinOpen = true;
        this.zoom = closerZoom;
      }
    },

    computeDistance() {
      this.markers.forEach((marker) => {
        let center = new window.google.maps.LatLng(this.center);
        let targetLoc = new window.google.maps.LatLng(marker.position);
        let distance = window.google.maps.geometry.spherical.computeDistanceBetween(
          center,
          targetLoc
        );
        marker["distance"] = distance;
      });
    },

    setPlace(place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.place = place;
      this.computeDistance();
      this.updateLocations();
      this.center = {
        lat: this.markers[0].position.lat,
        lng: this.markers[0].position.lng,
      };
    },
    sortMarkers() {
      this.markers.sort((a, b) => a.distance - b.distance);
    },
    updateLocations() {
      this.sortMarkers();
      this.zoom = closerZoom;
    },
    selectProvider(marker) {
      this.center = { lat: marker.position.lat, lng: marker.position.lng };
      this.zoom = providerSelectedZoom;
      this.$emit("change", marker.provider);
    },
    providersChanged() {
      this.markers = this.providers.map(providerToMarker);
    },
  },
  mounted() {
    this.providersChanged();
  },
};
</script>

<style scoped>
h1 {
  margin-bottom: 50px;
  text-align: center;
}
.info-window p {
  margin-bottom: 5px;
}
.vue-map-container {
  display: inline-block;
  width: 100%;
  height: 53vh;
}
.search {
  padding: 12px 0;
  display: flex;
}
.search button {
  margin-left: 10px;
  padding: 2px 0.75rem;
}
label {
  padding-right: 10px;
}
select {
  height: 31px;
}
.buttons {
  margin-top: 0.5rem;
}
@media screen and (max-width: 767px) {
  .search {
    flex-direction: column;
  }
  .search > *,
  .search input {
    display: block;
    width: 100%;
  }
  .search label {
    padding-right: 0;
  }
}
</style>
